import _slicedToArray from "/codebuild/output/src3434728972/src/landings/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import useQueryParams from "./useQueryParams";
var QueryParams = function QueryParams(_ref) {
  var config = _ref.config,
    children = _ref.children;
  var _useQueryParams = useQueryParams(config),
    _useQueryParams2 = _slicedToArray(_useQueryParams, 2),
    query = _useQueryParams2[0],
    setQuery = _useQueryParams2[1];
  return children({
    query: query,
    setQuery: setQuery
  });
};
var QueryParams_default = QueryParams;
export { QueryParams, QueryParams_default as default };